import Avatar from '@atlaskit/avatar';
import AvatarGroup from '@atlaskit/avatar-group';
import { inject, observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import { Contributor } from '../../clients/activities/model';
import UIStore from '../../store/uiStore';
import UserStore from '../../store/userStore';
import { popEvent } from '../../util/event';
import WrappedWithProfilecard from '../WrappedWithProfilecard';

interface Props {
  cloudId: string;
  contributors: Contributor[];
  siteUrl: string;
  uiStore: UIStore;
  userStore: UserStore;
}

const Container = styled.span`
  display: flex;
  flex: 1;
  flex-direction: row-reverse;
  margin-top: -4px;
  margin-bottom: -4px;
  width: 100%;
`;

interface AkAvatarGroupProps {
  accountID: string;
  key: string;
  name?: string;
  src: string;
}
function transformContributorData(contributors: Contributor[]): AkAvatarGroupProps[] {
  return contributors.map(contributor => ({
    accountID: contributor.accountID,
    key: contributor.accountID,
    name: contributor.name,
    src: contributor.picture,
  }));
}

const DESKTOP_MAX_CONTRIBUTORS = 4;
const MOBILE_MAX_CONTRIBUTORS = 3;

@observer
class Contributors extends React.Component<Props> {
  render() {
    // oldest contributor is first
    const { contributors, userStore } = this.props;
    const { mobileMode } = this.props.uiStore;

    const maxContributors = mobileMode ? MOBILE_MAX_CONTRIBUTORS : DESKTOP_MAX_CONTRIBUTORS;
    const avatarSize = mobileMode ? 'small' : 'medium';

    const currentUserId = userStore.accountId;
    const contributorsWithoutCurrent = contributors.filter(contributor => contributor.accountID !== currentUserId);
    // Transform data to be compatible with AvatarGroup
    const contrib = transformContributorData(contributorsWithoutCurrent);

    // Consume the click event so it doesn't bubble up and cause the link to be clicked instead.
    return (
      <Container onClick={popEvent} data-test-id="contributors-group">
        <AvatarGroup maxCount={maxContributors} avatar={this.ProfileAvatar} size={avatarSize} data={contrib} />
      </Container>
    );
  }

  // Props contain bunch of sizing + styling values from AvatarGroup
  private ProfileAvatar = (props: AkAvatarGroupProps) => {
    const { accountID } = props;
    const { cloudId, siteUrl } = this.props;

    return (
      <WrappedWithProfilecard cloudId={cloudId} siteUrl={siteUrl} userId={accountID}>
        <Avatar {...props} />
      </WrappedWithProfilecard>
    );
  };
}

export default inject(({ userStore, uiStore }) => ({ userStore, uiStore }))(Contributors);
